import Breadcrumbs from "../../components/Common/Breadcrumb"
import React from "react"
import { Container } from "reactstrap"
import { withTranslation } from "react-i18next"

const Report = props => {

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Gestion des Parniers Suprises")}
                       breadcrumbItem={props.t("Paniers - Gestion et Optimisation")} />

          Rapports & analytics
        </Container>
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(Report);
